import ShoppingCartsWithData from "./ShoppingCartsWithData";

export default ShoppingCartsWithData;